import React from 'react';

const Pentesting = ({ language }) => {
  const translations = {
    de: {
      pentesting_title: "Pentesting",
      pentesting_p1: "Ich arbeite bereits seit Anfang 2025 als <b>Junior Penetration Tester</b> bei der <b>TÜV Trust IT TÜV Austria GmbH</b>. Dabei kann ich mein Wissen besonders bei Webapplikations-, Clientapplikations-, Netzwerkinfrastruktur- und API-Tests einbringen. Penetrationtesting-Tools wie Burp Suite, Nessus, Nmap, Metasploit und viele mehr gehören dadurch zu meinem Alltag.",
      pentesting_p2: "Aktuell absolviere ich meinen <b>Master in IT Security</b> an der <b>Hochschule Campus Wien (HCW)</b>, nachdem ich dort bereits meinen <b>Bachelor in Computer Science and Digital Communications</b> abgeschlossen habe. Dadurch verbinde ich fundiertes theoretisches Wissen mit praktischer Erfahrung aus zahlreichen Assessments. Nebenbei vertiefe ich mein Penetration-Testing-Wissen kontinuierlich durch praxisorientierte <b>Zertifizierungen</b> wie den CISCO Ethical Hacker und den HTB CPTS.",
      tools_title: "Tools",
      tests_title: "Spezialisierung",
      tools_list: ["Burp Suite", "Nessus", "Nmap", "Metasploit"],
      tests_list: ["Web Applikationen", "Client Applikationen", "Netzwerk", "API"]
    },
    en: {
      pentesting_title: "Pentesting",
      pentesting_p1: "I have been working as a <b>Junior Penetration Tester</b> since early 2025 at <b>TÜV Trust IT TÜV Austria GmbH</b>. In this role, I apply my expertise particularly in web application, client application, network infrastructure, and API testing. Penetration testing tools such as Burp Suite, Nessus, Nmap, Metasploit, and many others are part of my daily routine.",
      pentesting_p2: "I am currently pursuing my <b>Master's degree in IT Security</b> at the <b>Campus Wien University of Applied Sciences (HCW)</b>, having previously completed my <b>Bachelor's in Computer Science and Digital Communications</b> there. This allows me to combine solid theoretical knowledge with hands-on assessment experience. In addition, I continuously deepen my penetration testing skills through practical <b>certifications</b> such as CISCO Ethical Hacker and HTB CPTS.",
      tools_title: "Tools",
      tests_title: "Specialization",
      tools_list: ["Burp Suite", "Nessus", "Nmap", "Metasploit"],
      tests_list: ["Web Applications", "Client Application", "Network", "API"]
    }
  };

  const t = translations[language];

  return (
    <>
      <h2>{t.pentesting_title}</h2>

      <div className="about-text-card" style={{ marginTop: '1.5rem', marginBottom: '2rem' }}>
        <p dangerouslySetInnerHTML={{ __html: t.pentesting_p1 }} />
        <p dangerouslySetInnerHTML={{ __html: t.pentesting_p2 }} />
      </div>

      <div className="skills-section">
        <h3>{t.tools_title}</h3>
        <div className="skills-container" style={{ marginBottom: '2rem' }}>
          {t.tools_list.map((tool, index) => (
            <span key={`tool-${index}`} className="skill-badge">{tool}</span>
          ))}
        </div>

        <h3>{t.tests_title}</h3>
        <div className="skills-container">
          {t.tests_list.map((test, index) => (
            <span key={`test-${index}`} className="skill-badge">{test}</span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Pentesting;
